<bar-loader [loading]="loading$ | async"></bar-loader>
<div *hasRole="FAMILY_OR_CUSTOMER">
  <!-- As a family member, you only see your own assigned communities-->
  @if ((myCustomers.data | async)?.length > 0) {
    <ng-container
      *ngTemplateOutlet="
        customerList;
        context: {
          paginator: false,
          dataSource: myCustomers,
          tabName: MY_CUSTOMERS
        }
      "
  ></ng-container>
} @else {
  <p *hasRole="FAMILY">
    {{ "customerFilter.noAssignedCommunities" | translate }}
  </p>
  <p *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES">
    {{ "customerFilter.noAssignedCustomers" | translate }}
  </p>
}
</div>
<ng-container *hasRole="CARER">
  @if (!(canAccessAllCustomers$ | async)) {
    <mat-tab-group
      mat-stretch-tabs="false"
      mat-align-tabs="start"
      [selectedIndex]="selectedTab.value"
      (selectedIndexChange)="selectedTab.setValue($event)"
      >
      <!--
      As a normal carer, you see your own assigned communities by default, but can also search
      all communities (provided the search string is longer than 2 characters)
      -->
      <mat-tab [label]="'customerFilter.my' | translate">
        @if ((myCustomers.data | async)?.length > 0) {
          <ca-customer-filter
            [sortMethod]="sortMethod"
            (onSortMethodChange)="updateCustomerSort($event)"
            >
          </ca-customer-filter>
          <ng-container
          *ngTemplateOutlet="
            customerList;
            context: {
              paginator: false,
              dataSource: myCustomers,
              tabName: MY_CUSTOMERS
            }
          "
        ></ng-container>
      } @else {
        <p *hasRole="FAMILY">
          {{ "customerFilter.noAssignedCommunities" | translate }}
        </p>
        <p *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES">
          {{ "customerFilter.noAssignedCustomers" | translate }}
        </p>
      }
    </mat-tab>
    @if (!hideUnassigned) {
      <mat-tab
        [label]="'customerFilter.search' | translate"
        >
        <ng-container *ngTemplateOutlet="searchField"></ng-container>
        @if (search.length > 2 && !(loading$ | async)) {
          <ng-container
          *ngTemplateOutlet="
            customerList;
            context: {
              paginator: true,
              dataSource: customers,
              tabName: ALL_CUSTOMERS
            }
          "
        ></ng-container>
      } @else {
        <p *hasRole="FAMILY">
          {{ "customerFilter.emptySearch" | translate }}
        </p>
        <p *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES">
          {{ "customerFilter.emptySearchCustomers" | translate }}
        </p>
      }
    </mat-tab>
  }
  @if (!!multiple) {
    <mat-tab [label]="'customerList.tabTitle' | translate">
      @if (
        (customerListsDataSource.data | async)?.length > 0) {
        <ng-container
            *ngTemplateOutlet="
              customerLists;
              context: {
                paginator: false,
                dataSource: customerListsDataSource,
                tabName: CUSTOMER_LISTS
              }
            "
      ></ng-container>
    } @else {
      <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
      <div class="emptyList">
        {{ "customerList.noLists" | translate }}
      </div>
    }
  </mat-tab>
}
</mat-tab-group>
} @else {
  <!-- Qualified carers and above can view a full customer list without searching -->
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [selectedIndex]="selectedTab.value"
    (selectedIndexChange)="selectedTab.setValue($event)"
    >
    <mat-tab [label]="'customerFilter.search' | translate">
      <ng-container *ngTemplateOutlet="addCustomerActions"></ng-container>
      <ng-component *ngTemplateOutlet="orgWideSearch"></ng-component>
    </mat-tab>
    @if (!!multiple) {
      <mat-tab [label]="'customerList.tabTitle' | translate">
        @if (
          (customerListsDataSource.data | async)?.length > 0) {
          @if (
            (customerListsDataSource.data | async)?.length > 0) {
            <ng-container
              *ngTemplateOutlet="addCustomerListActions"
            ></ng-container>
            <ng-container
            *ngTemplateOutlet="
              customerLists;
              context: {
                paginator: false,
                dataSource: customerListsDataSource,
                tabName: CUSTOMER_LISTS
              }
            "
          ></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
          <div class="emptyList">
            {{ "customerList.noLists" | translate }}
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
        <div class="emptyList">
          {{ "customerList.noLists" | translate }}
        </div>
      }
    </mat-tab>
  }
</mat-tab-group>
}
</ng-container>

<!--
A Provider Administrator will be given an Org Admin role when browsing
through an organisation, so we need to stop double-up of the customer list.
-->
@if (adminRoute) {
  <ng-container *hasRole="TENANT_ADMINISTRATION_ROLES">
    <ng-container *ngTemplateOutlet="addCustomerActions"></ng-container>
    <ng-component *ngTemplateOutlet="orgWideSearch"></ng-component>
  </ng-container>
}
@if (!adminRoute) {
  <ng-container *hasRole="MANAGEMENT_ROLES">
    <!--
    As a coordinator that does not have 'oversee all customers', you see your own assigned
    customers by default, but can also search all communities.
    -->
    @if (
      (getIsCoordinatorAndDoesNotOverseeAll$ | async) == true) {
      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        [selectedIndex]="selectedTab.value"
        (selectedIndexChange)="selectedTab.setValue($event)"
        >
        <mat-tab [label]="'customerFilter.search' | translate">
          <ng-container *ngTemplateOutlet="addCustomerActions"></ng-container>
          <ng-component *ngTemplateOutlet="orgWideSearch"></ng-component>
        </mat-tab>
        <mat-tab [label]="'customerFilter.my' | translate">
          <ng-container *ngTemplateOutlet="addCustomerActions"></ng-container>
          @if ((myCustomers.data | async)?.length > 0) {
            <ng-container
              *ngTemplateOutlet="
                customerList;
                context: {
                  paginator: false,
                  dataSource: myCustomers,
                  tabName: MY_CUSTOMERS
                }
              "
          ></ng-container>
        } @else {
          <p *hasRole="FAMILY">
            {{ "customerFilter.noAssignedCommunities" | translate }}
          </p>
          <p *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES">
            {{ "customerFilter.noAssignedCustomers" | translate }}
          </p>
        }
      </mat-tab>
      @if (!!multiple) {
        <mat-tab [label]="'customerList.tabTitle' | translate">
          @if (
            (customerListsDataSource.data | async)?.length > 0) {
            <ng-container
              *ngTemplateOutlet="addCustomerListActions"
            ></ng-container>
            <ng-container
                *ngTemplateOutlet="
                  customerLists;
                  context: {
                    paginator: false,
                    dataSource: customerListsDataSource,
                    tabName: CUSTOMER_LISTS
                  }
                "
          ></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
          <div class="emptyList">
            {{ "customerList.noLists" | translate }}
          </div>
        }
      </mat-tab>
    }
  </mat-tab-group>
} @else {
  <!-- Qualified carers and above can view a full customer list without searching -->
  <mat-tab-group
    mat-stretch-tabs="false"
    mat-align-tabs="start"
    [selectedIndex]="selectedTab.value"
    (selectedIndexChange)="selectedTab.setValue($event)"
    >
    <mat-tab [label]="'customerFilter.search' | translate">
      <ng-container *ngTemplateOutlet="addCustomerActions"></ng-container>
      <ng-component *ngTemplateOutlet="orgWideSearch"></ng-component>
    </mat-tab>
    @if (!!multiple) {
      <mat-tab [label]="'customerList.tabTitle' | translate">
        @if (
          (customerListsDataSource.data | async)?.length > 0) {
          @if (
            (customerListsDataSource.data | async)?.length > 0) {
            <ng-container
              *ngTemplateOutlet="addCustomerListActions"
            ></ng-container>
            <ng-container
            *ngTemplateOutlet="
              customerLists;
              context: {
                paginator: false,
                dataSource: customerListsDataSource,
                tabName: CUSTOMER_LISTS
              }
            "
          ></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
          <div class="emptyList">
            {{ "customerList.noLists" | translate }}
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="addCustomerListActions"></ng-container>
        <div class="emptyList">
          {{ "customerList.noLists" | translate }}
        </div>
      }
    </mat-tab>
  }
</mat-tab-group>
}
</ng-container>
}



<ng-template #emptySearch>
  <p *hasRole="FAMILY">
    {{ "customerFilter.emptySearch" | translate }}
  </p>
  <p *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES">
    {{ "customerFilter.emptySearchCustomers" | translate }}
  </p>
</ng-template>

<ng-template #orgWideSearch>
  <ng-container *ngTemplateOutlet="searchField"></ng-container>
  <ng-container
    *ngTemplateOutlet="
      customerList;
      context: {
        paginator: true,
        dataSource: customers,
        tabName: ALL_CUSTOMERS
      }
    "
></ng-container>
</ng-template>

<ng-template #searchField>
  <ca-customer-filter
    [showEnabledToggle]="link != null"
    [enabledOnly]="enabledOnly"
    [sortMethod]="sortMethod"
    (onSortMethodChange)="updateCustomerSort($event)"
    (onEnabledOnlyChange)="updateCustomerEnabled($event)"
    >
  </ca-customer-filter>
  <ca-form-field class="searchField">
    <input
      caInput
      onLightBackground="true"
      type="text"
      placeholder="Filter"
      [(ngModel)]="search"
      />
    @if (search.length > 0) {
      <button
        ca-action-button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="search = ''"
        >
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-hint *hasRole="FAMILY" align="start">{{
      "customerFilter.searchHint" | translate
    }}</mat-hint>
    <mat-hint
      *hasRole="STAFF_AND_TENANT_ROLES_AND_MANAGEMENT_ROLES"
      align="start"
      >{{ "customerFilter.searchHintCustomers" | translate }}</mat-hint
      >
    </ca-form-field>
  </ng-template>

  <ng-template #addCustomerActions>
    <ng-container *hasRole="CUSTOMER_CREATION_ROLES">
      @if (showCreateActions) {
        <div class="addCustomerActions">
          <a [routerLink]="['new']" ca-raised-button class="create" color="primary"
            >New Customer</a
            >
            <a
              *hasRole="BULK_IMPORT_ROLES"
              [routerLink]="['import']"
              ca-raised-button
              color="primary"
              class="bulk-import"
              >Bulk Import Customers</a
              >
            </div>
          }
        </ng-container>
      </ng-template>

<ng-template #addCustomerListActions>
  <ng-container *hasRole="CUSTOMER_CREATION_ROLES">
    @if (showCreateActions) {
      <div class="addCustomerListActions">
        <a
          [routerLink]="['../', 'customer-lists', 'create']"
          ca-raised-button
          class="create"
          color="primary"
          >New Customer List</a
        >
      </div>
    }
  </ng-container>
</ng-template>

        <ng-template
          #customerList
          let-paginator="paginator"
          let-dataSource="dataSource"
          let-tabName="tabName"
          >
          <data-list-table
            [config]="tableConfig"
            [link]="link"
            [dividers]="false"
            [headings]="false"
            [paginator]="paginator"
            [dataSource]="dataSource"
            [sort]="(filter$ | async)?.order"
            [page]="page$ | async"
            (onSort)="sort($event)"
            (onPage)="paginate($event)"
            >
            <div
              class="customer-row"
              matRipple
              *dataListCellRenderer="'name'; let row"
              [class.selected]="selectedIds?.includes(row?.id) ?? false"
              [matRippleDisabled]="disabledCustomers?.get(row.id)"
              [class.disabled]="disabledCustomers?.get(row.id)"
      (click)="
        disabledCustomers.get(row.id) ? noop() : customerSelected.emit(row)
      "
              >
              <div class="flex flex-row items-center">
                <div class="avatar">
                  <ca-avatar
                    [fullName]="row | displayname"
            [image]="
              row.profileImage != null
                ? (row.profileImage | filedownloadurl : 'sizeTiny' | async)
                : null
            "
            [blur]="
              row.profileImage != null
                ? (row.profileImage | mediaBlurUrl)
                : null
            "
                    >
                  </ca-avatar>
                </div>
                <div class="customer-name">
                  <h3>{{ row | displayname }}</h3>
                  @if (row.lastContentAt == null) {
                    <p class="lastContentDisplay">
                      {{ "contentType.none" | translate }}
                    </p>
                  }
                  @if (row.lastContentAt != null) {
                    <p class="lastContentDisplay">
                      <mat-icon>
                        {{ row.lastContentType | contentTypeIcon }}
                      </mat-icon>
                      {{ "contentType." + row.lastContentType | translate }}
                      {{ row.lastContentAt | fromNow }}
                    </p>
                  }
                  @if (disableNoMedia && row.settings?.allowMemoImages == false) {
                    <p
                      class="warning flex justify-center"
                      >
                      <mat-icon class="pe-1">no_photography</mat-icon>
                      {{ "customerFilter.noMedia" | translate : { name: row.firstName } }}
                    </p>
                  }
                  @if (!disableNoMedia && row.settings?.allowMemoImages == false) {
                    <p
                      class="info"
                      >
                      <mat-icon>no_photography</mat-icon>
                    </p>
                  }
                  <ng-container *hasRole="CAN_VIEW_DISABLED_WARNING">
                    @if (row.enabled == false) {
                      <p class="warning">
                        {{ "customerFilter.disabled" | translate }}
                      </p>
                    }
                  </ng-container>
                  @if (showOrganisation) {
                    <p class="info organisationName">
                      {{ (allOrganisations$ | async)[row.organisationId]?.name }}
                    </p>
                  }
                </div>
              </div>
              @if (showStars && (accessAllCustomers$ | async) === false) {
                <div
                  class="starContainer"
                  >
                  <ng-container *hasRole="COORDINATOR">
                    <!--
                    :NOTE: (Trent Bowden, 3 Nov 21) In the "My customers" tab, the MemberCustomers
                    state does not provide roles, so row.roles is undefined. The existence of a row
                    in the "My" tab implies a filled star should be shown.
                    -->
                    @if (
                      tabName == MY_CUSTOMERS ||
                      (row?.roles?.includes(CUSTOMER_COORDINATOR) ?? false)) {
                      <div
                        class="star"
                        >
                        <mat-icon
                          (click)="removeCustomerCoordinator($event, row)"
                          [matTooltip]="'customerFilter.unstarCustomer' | translate"
                          >star</mat-icon
                          >
                        </div>
                      } @else {
                        <div
                          class="star"
                          [matTooltip]="'customerFilter.starCustomer' | translate"
                          >
                          <mat-icon (click)="addCustomerCoordinator($event, row)"
                            >star_outline</mat-icon
                            >
                          </div>
                        }
                      </ng-container>
                    </div>
                  }
                </div>
              </data-list-table>
            </ng-template>

            <ng-template #customerLists>
              <data-list-table
                [config]="customerListTableConfig"
                [link]="link"
                [navigationOptions]="navigationOptions"
                [dividers]="false"
                [headings]="false"
                [dataSource]="customerListsDataSource"
                >
                <div
                  class="customer-list-row"
                  matRipple
                  *dataListCellRenderer="'name'; let row"
                  [matRippleDisabled]="false"
                  [class.disabled]="false"
                  (click)="customerListSelected.emit(row)"
                  [class.selected]="selectedCustomerListIds | arrayIncludes : row.id"
                  >
                  @if (row.customerIds | customersFromIds | async; as rowCustomers) {
                    <div class="flex flex-row items-center">
                      <div class="avatar">
                        <!-- It is possible for a customer list to be empty. In this case,
                        We want the list name initials to appear in the avatar. -->
                        <ca-avatar
                          [fullName]="row.name"
              [image]="
                rowCustomers?.length[0]?.profileImage | filedownloadurl | async
              "
                        ></ca-avatar>
                      </div>
                      <div>
                        <div class="customer-list-name">
                          <h3>{{ row.name }}</h3>
                        </div>
                        @if (
                          rowCustomers
                          | filter
                          : customerAllowsMediaFilter(false); as customersWithNoMedia
                          ) {
                          @if (
                            disableNoMedia &&
                            (selectedCustomerListIds | arrayIncludes : row.id) &&
                            customersWithNoMedia.length
                            ) {
                            <div
                              >
                              @if (customersWithNoMedia.length == 1) {
                                <p class="info">
                                  {{
                                  "customerList.customerPhotosBlocked.one"
                                  | translate
                                  : { name: (customersWithNoMedia[0] | displayname) }
                                  }}
                                </p>
                              }
                              @if (customersWithNoMedia.length > 1) {
                                <p class="info">
                                  {{
                                  "customerList.customerPhotosBlocked.other"
                                  | translate : { value: customersWithNoMedia.length }
                                  }}
                                </p>
                              }
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              </data-list-table>
            </ng-template>
